import React, { useState, useEffect } from 'react';
import { formatearMoneda } from '../utils/moneda';
import ClienteForm from './ClienteForm';
import VentaModal from '../components/VentaModal';
import { obtenerClientes, obtenerClienteCompleto, actualizarEstadoAnteojo, editarAnteojo, eliminarAnteojo, editarCliente, eliminarCliente, obtenerCristalesPorTipo, obtenerPreviewWhatsApp, obtenerPreviewReview, obtenerVentas, eliminarVenta, obtenerResumenGarantías, actualizarEstadoReviewCliente, listarFacturasCliente, descargarFacturaPDF } from '../api/backend_v2';
import Swal from 'sweetalert2';
import AnteojoDetalle from './AnteojoDetalle';
import PrintSobre from './PrintSobre';
import { formatearFechaArgentina } from '../utils/fechas';
import { mostrarModalReview, calcularTiempoTranscurrido } from '../utils/reviewHelper';
import { construirUrlWhatsApp, formatearTelefonoWhatsApp } from '../utils/whatsappHelper';
import { MagnifyingGlassIcon, BanknotesIcon, CreditCardIcon, PencilIcon, EyeIcon, TrashIcon, PlusIcon, UserIcon, UsersIcon, ExclamationTriangleIcon, ArrowPathIcon, ChartBarIcon, ClipboardDocumentListIcon, PhoneIcon, CalendarIcon, XMarkIcon, PrinterIcon, BookOpenIcon, DocumentTextIcon, DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import { solicitarFacturacionAnteojo, solicitarFacturacionVenta, encontrarFacturaDeAnteojo, encontrarFacturaDeVenta, verODescargarFactura } from '../utils/facturacionBridge';

const ListaClientes = ({ onViewChange }) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);
  const [itemsPorPagina, setItemsPorPagina] = useState(10);

  const clientesFiltrados = busqueda.trim()
    ? clientes.filter(c => {
        const term = busqueda.toLowerCase().trim().replace(/\s+/g, ' ');
        const nombre = (c.nombre || '').toLowerCase();
        const apellido = (c.apellido || '').toLowerCase();
        const telefono = (c.telefono || '').toLowerCase();
        return (
          nombre.includes(term) ||
          apellido.includes(term) ||
          telefono.includes(term) ||
          `${nombre} ${apellido}`.includes(term) ||
          `${apellido} ${nombre}`.includes(term)
        );
      })
    : clientes;

  // Calcular paginación
  const totalPaginas = Math.ceil(clientesFiltrados.length / itemsPorPagina);
  const indiceInicio = (paginaActual - 1) * itemsPorPagina;
  const indiceFin = indiceInicio + itemsPorPagina;
  const clientesPaginados = clientesFiltrados.slice(indiceInicio, indiceFin);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [mostrarDetalles, setMostrarDetalles] = useState(false);
  const [actualizandoEstado, setActualizandoEstado] = useState(null);
  const [anteojoDetalle, setAnteojoDetalle] = useState(null);
  const [anteojoParaImprimir, setAnteojoParaImprimir] = useState(null);
  const [mostrarSobreNuevo, setMostrarSobreNuevo] = useState(false);

  // Nuevo: para mostrar el modal de ClienteForm en modo agregar anteojo
  const [mostrarAgregarAnteojo, setMostrarAgregarAnteojo] = useState(false);
  const [clienteParaAgregarAnteojo, setClienteParaAgregarAnteojo] = useState(null);
  const [ultimoAnteojoCliente, setUltimoAnteojoCliente] = useState(null);
  const [origenBeneficioAnteojo, setOrigenBeneficioAnteojo] = useState(null);
  const [cargandoModal, setCargandoModal] = useState(false);
  const [beneficiosDisponiblesPorAnteojo, setBeneficiosDisponiblesPorAnteojo] = useState({});

  // Estados para edición de cliente
  const [editandoCliente, setEditandoCliente] = useState(false);
  const [datosEdicionCliente, setDatosEdicionCliente] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    padre_madre_encargado: '',
    domicilio: '',
    email: '',
    obra_social: '',
    observaciones: ''
  });

  // Estados para agregar venta a cliente
  const [mostrarAgregarVenta, setMostrarAgregarVenta] = useState(false);
  const [clienteParaAgregarVenta, setClienteParaAgregarVenta] = useState(null);
  
  // Estado para las ventas del cliente seleccionado
  const [ventasCliente, setVentasCliente] = useState([]);
  const [facturasCliente, setFacturasCliente] = useState([]);

  // Estado para resumen de garantías por cliente
  const [resumenGarantiasPorCliente, setResumenGarantiasPorCliente] = useState({});

  // Estados para editar venta
  const [mostrarEditarVenta, setMostrarEditarVenta] = useState(false);
  const [ventaParaEditar, setVentaParaEditar] = useState(null);

  // Estados para eliminar venta
  const [ventaParaEliminar, setVentaParaEliminar] = useState(null);

  const esAnteojoCreadoPorBeneficio = (anteojo) => {
    const texto = String(anteojo?.observaciones || '').toLowerCase();
    return texto.includes('lente por seguro') || texto.includes('lente por promocion');
  };

  const obtenerDistanciaMonofocal = (anteojo) => {
    const tipo = (anteojo.tipo_anteojo || '').toLowerCase();
    
    // Si es monofocal, retornar si es lejos o cerca
    if (tipo === 'monofocal') {
      if (anteojo.lejos_cristal) {
        return 'lejos';
      } else if (anteojo.cerca_cristal) {
        return 'cerca';
      }
    }
    
    return null;
  };

  const obtenerColorDistancia = (distancia) => {
    if (distancia === 'lejos') {
      return 'bg-blue-100 text-blue-800 border border-blue-300';
    } else if (distancia === 'cerca') {
      return 'bg-amber-100 text-amber-800 border border-amber-300';
    }
    return '';
  };

  const obtenerTipoAnteojoConDistancia = (anteojo) => {
    const tipo = anteojo.tipo_anteojo || 'General';
    
    // Si es monofocal, agregar indicación de lejos o cerca
    if (tipo.toLowerCase() === 'monofocal') {
      if (anteojo.lejos_cristal) {
        return `${tipo} (Lejos)`;
      } else if (anteojo.cerca_cristal) {
        return `${tipo} (Cerca)`;
      }
    }
    
    return tipo;
  };

  useEffect(() => {
    cargarClientes();
  }, []);

  useEffect(() => {
    let activo = true;

    const normalizar = (valor) => String(valor || '').toLowerCase().trim().replace(/\s+/g, ' ');
    const extraerMarca = (valor) => {
      const texto = String(valor || '').trim();
      if (!texto) return '';
      const idx = texto.indexOf('-');
      if (idx >= 0) {
        const marca = texto.slice(idx + 1).trim();
        return marca || texto;
      }
      return texto;
    };

    const cargarBeneficiosDisponibles = async () => {
      const anteojos = clienteSeleccionado?.anteojos || [];
      if (anteojos.length === 0) {
        if (!activo) return;
        setBeneficiosDisponiblesPorAnteojo({});
        return;
      }

      try {
        const tiposUnicos = [...new Set(anteojos.map((a) => a.tipo_anteojo).filter(Boolean))];
        const respuestas = await Promise.all(
          tiposUnicos.map(async (tipo) => {
            try {
              const response = await obtenerCristalesPorTipo(tipo);
              return { tipo, cristales: response?.cristales || [] };
            } catch {
              return { tipo, cristales: [] };
            }
          })
        );

        const cristalesPorTipo = respuestas.reduce((acc, item) => {
          acc[item.tipo] = item.cristales;
          return acc;
        }, {});

        const mapa = {};
        anteojos.forEach((anteojo) => {
          const cristalesTipo = cristalesPorTipo[anteojo.tipo_anteojo] || [];
          const nombresCristal = [anteojo.lejos_cristal, anteojo.cerca_cristal]
            .map(extraerMarca)
            .filter(Boolean)
            .map(normalizar);

          const coincidentes = cristalesTipo.filter((cristal) => {
            const nombreProductoNormalizado = normalizar(cristal.producto);
            const marcaNormalizada = normalizar(cristal.marca);
            
            return nombresCristal.some(nombreForm => 
              nombreForm.includes(nombreProductoNormalizado) && nombreForm.includes(marcaNormalizada)
            );
        });

          mapa[anteojo.id] = {
            seguro: coincidentes.some((c) => !!c.tiene_seguro),
            promocion: coincidentes.some((c) => !!c.tiene_promocion),
          };
        });

        if (!activo) return;
        setBeneficiosDisponiblesPorAnteojo(mapa);
      } catch {
        if (!activo) return;
        setBeneficiosDisponiblesPorAnteojo({});
      }
    };

    cargarBeneficiosDisponibles();

    return () => {
      activo = false;
    };
  }, [clienteSeleccionado]);

  const cargarClientes = async () => {
    try {
      setLoading(true);
      const response = await obtenerClientes();
      setClientes(response.clientes || []);
      setPaginaActual(1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBusqueda = (e) => {
    setBusqueda(e.target.value);
    setPaginaActual(1);
  };

  const verDetallesCliente = async (clienteId) => {
    try {
      setLoading(true);
      const clienteCompleto = await obtenerClienteCompleto(clienteId);
      setClienteSeleccionado(clienteCompleto);
      
      // Cargar ventas del cliente
      try {
        const respuestaVentas = await obtenerVentas({ cliente_id: clienteId });
        setVentasCliente(respuestaVentas.ventas || []);
      } catch (err) {
        console.warn('Error al cargar ventas del cliente:', err);
        setVentasCliente([]);
      }

      // Cargar facturas emitidas del cliente
      try {
        const respuestaFacturas = await listarFacturasCliente(clienteId);
        setFacturasCliente(respuestaFacturas.facturas || []);
      } catch (err) {
        console.warn('Error al cargar facturas del cliente:', err);
        setFacturasCliente([]);
      }

      // Cargar resumen de garantías
      try {
        const resumenGarantias = await obtenerResumenGarantías(clienteId);
        setResumenGarantiasPorCliente(prev => ({
          ...prev,
          [clienteId]: resumenGarantias
        }));
      } catch (err) {
        console.warn('Error al cargar garantías:', err);
      }
      
      
      setMostrarDetalles(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
   
  };

  const cambiarEstadoAnteojo = async (anteojoId, nuevoEstado) => {
    try {
      setActualizandoEstado(anteojoId);
      const respuesta = await actualizarEstadoAnteojo(anteojoId, nuevoEstado);
      // Recargar detalles del cliente para ver los cambios
      const actualizado = await obtenerClienteCompleto(clienteSeleccionado.id);
      setClienteSeleccionado(actualizado);
      // Si el anteojo en detalle es el que cambió, actualiza el modal
      if (anteojoDetalle && anteojoDetalle.id === anteojoId) {
        setAnteojoDetalle(actualizado.anteojos.find(a => a.id === anteojoId));
      }

      if (nuevoEstado === 'Entregado') {
        try {
          const preview = await obtenerPreviewReview(anteojoId);
          await mostrarModalReview({
            preview,
            Swal,
            formatearTelefonoWALista: formatearTelefonoWhatsApp,
            onReviewRegistrada: async () => {
              if (clienteSeleccionado) {
                const act = await obtenerClienteCompleto(clienteSeleccionado.id);
                setClienteSeleccionado(act);
              }
              const todos = await obtenerClientes();
              if (Array.isArray(todos?.clientes)) setClientes(todos.clientes);
              else if (Array.isArray(todos)) setClientes(todos);
            },
          });
        } catch (reviewError) {
          console.error('Error al obtener preview de review:', reviewError);
          // Si falla el preview de review, mostrar el mensaje de éxito estándar
          await Swal.fire({
            title: '✅ Anteojo entregado',
            html: respuesta?.ingreso_registrado
              ? `<p class="text-gray-700">El saldo pendiente de <strong>${formatearMoneda(respuesta.saldo_cobrado)}</strong> fue registrado como ingreso correctamente.</p>`
              : `<p class="text-gray-700">El anteojo fue marcado como entregado correctamente.</p>`,
            icon: 'success',
            confirmButtonText: 'Aceptar',
          });
        }
      } else if (nuevoEstado === 'Para retirar') {
        try {
          const preview = await obtenerPreviewWhatsApp(anteojoId);
          const urlWA = construirUrlWhatsApp(preview.telefono, preview.mensaje);
          const infoDestinatario = preview.hay_tutor
            ? `<strong>${preview.destinatario_nombre}</strong> (tutor/a de <em>${preview.cliente_nombre}</em>)`
            : `<strong>${preview.destinatario_nombre}</strong>`;

          await Swal.fire({
            title: '📦 Listo para retirar',
            html: `<p class="text-sm text-gray-600 mb-3">¿Querés notificar a ${infoDestinatario} por WhatsApp?</p><div class="bg-gray-50 border rounded p-3 text-left text-sm whitespace-pre-wrap text-gray-800 mb-4" style="max-height:200px;overflow-y:auto">${preview.mensaje}</div><a href="${urlWA}" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-green-500 text-white font-semibold hover:bg-green-600">💬 Abrir WhatsApp</a>`,
            showConfirmButton: false,
            showCloseButton: true,
          });
        } catch (whatsappError) {
          console.error('Error al obtener preview de WhatsApp:', whatsappError);
          // Mostrar un SWal de éxito igual pero sin el preview de WhatsApp
          await Swal.fire({
            title: '\ud83d\udce6 Listo para retirar',
            html: `<p class="text-gray-700">El anteojo fue marcado como "Para retirar" correctamente.</p><p class="text-sm text-gray-500 mt-2">No se pudo generar el preview de WhatsApp: ${whatsappError.message || 'Error desconocido'}</p>`,
            icon: 'success',
            confirmButtonText: 'Aceptar',
          });
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setActualizandoEstado(null);
    }
  };

  const abrirModalAgregarAnteojo = (cliente, anteojoBase = null, origenBeneficio = null) => {
    if (!cliente) return;
    setMostrarDetalles(false);
    setAnteojoDetalle(null);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setClienteParaAgregarAnteojo(cliente);
        setUltimoAnteojoCliente(anteojoBase);
        setOrigenBeneficioAnteojo(origenBeneficio);
        setMostrarAgregarAnteojo(true);
      });
    });
  };

  const handleAplicarBeneficioYReplicar = async (anteojoActualizado, campoBeneficio = null) => {
    if (!clienteSeleccionado) return;

    const actualizado = await obtenerClienteCompleto(clienteSeleccionado.id);
    setClienteSeleccionado(actualizado);

    const anteojoBase =
      actualizado.anteojos?.find((a) => a.id === anteojoActualizado.id) || anteojoActualizado;

    const origenBeneficio = campoBeneficio === 'usa_seguro'
      ? 'seguro'
      : campoBeneficio === 'usa_promocion'
        ? 'promocion'
        : anteojoBase?.usa_seguro
          ? 'seguro'
          : anteojoBase?.usa_promocion
            ? 'promocion'
            : null;

    abrirModalAgregarAnteojo(actualizado, anteojoBase, origenBeneficio);
  };

  const activarBeneficioDesdeLista = async (anteojo, campoBeneficio) => {
    if (!anteojo || !campoBeneficio) return;

    const etiqueta = campoBeneficio === 'usa_seguro' ? 'Seguro' : 'Promoción';
    const yaActivo = campoBeneficio === 'usa_seguro' ? !!anteojo.usa_seguro : !!anteojo.usa_promocion;
    if (yaActivo) return;

    const result = await Swal.fire({
      title: `¿Aplicar ${etiqueta}?`,
      text: 'Se guardará en este anteojo y se abrirá la carga de uno nuevo con la misma graduación.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      setCargandoModal(true);
      await editarAnteojo(anteojo.id, { [campoBeneficio]: true });
      const anteojoActualizado = { ...anteojo, [campoBeneficio]: true };
      await handleAplicarBeneficioYReplicar(anteojoActualizado, campoBeneficio);
    } catch (err) {
      await Swal.fire({
        title: `Error al aplicar ${etiqueta.toLowerCase()}`,
        text: err.message || String(err),
        icon: 'error',
      });
    } finally {
      setCargandoModal(false);
    }
  };

  // Usar función utilitaria
  const formatearFecha = formatearFechaArgentina;

  const getEstadoColor = (estado) => {
    const colors = {
      'Tomado': 'bg-blue-200 text-blue-800',
      'Preparado': 'bg-yellow-200 text-yellow-800',
      'En laboratorio': 'bg-purple-200 text-purple-800',
      'Para retirar': 'bg-orange-200 text-orange-800',
      'Entregado': 'bg-green-200 text-green-800',
      'Anulado': 'bg-red-200 text-red-800',
    };
    return colors[estado] || 'bg-gray-100 text-gray-800';
  };

  // Eliminar anteojo (ahora dentro del componente, con acceso a los estados)
  const borrarAnteojo = async (anteojoId) => {
    const result = await Swal.fire({
      title: '¿Está seguro de borrar este anteojo?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, borrar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    });
    if (!result.isConfirmed) return;
    try {
      await eliminarAnteojo(anteojoId);
      await Swal.fire({
        title: 'Anteojo borrado',
        icon: 'success',
        timer: 1200,
        showConfirmButton: false
      });
      // Refrescar detalles del cliente
      if (clienteSeleccionado) {
        const actualizado = await obtenerClienteCompleto(clienteSeleccionado.id);
        setClienteSeleccionado(actualizado);
      }
      // Si el anteojo borrado estaba en detalle, cerrar el modal de detalle
      if (anteojoDetalle && anteojoDetalle.id === anteojoId) {
        setAnteojoDetalle(null);
      }
    } catch (err) {
      await Swal.fire({
        title: 'Error al borrar',
        text: err.message || String(err),
        icon: 'error',
      });
    }
  };

  // Funciones para edición de cliente
  const iniciarEdicionCliente = () => {
    if (clienteSeleccionado) {
      setDatosEdicionCliente({
        nombre: clienteSeleccionado.nombre || '',
        apellido: clienteSeleccionado.apellido || '',
        telefono: clienteSeleccionado.telefono || '',
        padre_madre_encargado: clienteSeleccionado.padre_madre_encargado || '',
        domicilio: clienteSeleccionado.domicilio || '',
        email: clienteSeleccionado.email || '',
        obra_social: clienteSeleccionado.obra_social || '',
        observaciones: clienteSeleccionado.observaciones || ''
      });
      setEditandoCliente(true);
    }
  };

  const cancelarEdicionCliente = () => {
    setEditandoCliente(false);
    setDatosEdicionCliente({
      nombre: '',
      apellido: '',
      telefono: '',
      padre_madre_encargado: '',
      domicilio: '',
      email: '',
      obra_social: '',
      observaciones: ''
    });
  };

  const guardarEdicionCliente = async () => {
    try {
      // Validar campos requeridos
      if (!datosEdicionCliente.nombre.trim() || !datosEdicionCliente.apellido.trim() || !datosEdicionCliente.telefono.trim()) {
        await Swal.fire({
          title: 'Campos requeridos',
          text: 'Nombre, apellido y teléfono son obligatorios',
          icon: 'warning'
        });
        return;
      }

      await editarCliente(clienteSeleccionado.id, datosEdicionCliente);
      
      // Actualizar el cliente seleccionado con los nuevos datos
      setClienteSeleccionado(prev => ({
        ...prev,
        ...datosEdicionCliente
      }));
      
      // Refrescar la lista de clientes
      cargarClientes();
      
      setEditandoCliente(false);
      
      await Swal.fire({
        title: 'Cliente actualizado',
        text: 'Los datos del cliente se han actualizado correctamente',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
      
    } catch (error) {
      await Swal.fire({
        title: 'Error al actualizar',
        text: error.message || 'No se pudo actualizar el cliente',
        icon: 'error'
      });
    }
  };

  const handleCambioEdicionCliente = (campo, valor) => {
    setDatosEdicionCliente(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const eliminarClienteCompleto = async () => {
    if (!clienteSeleccionado) return;
    
    const result = await Swal.fire({
      title: '¿Eliminar cliente?',
      html: `
        <div style="text-align:left; line-height:1.45;">
          <p style="margin:0 0 12px 0; text-align:center;">
            ¿Estás seguro de que deseas eliminar a
            <strong>${clienteSeleccionado.nombre} ${clienteSeleccionado.apellido}</strong>?
          </p>

          <p style="margin:0 0 8px 0; color:#dc2626; font-weight:700;">
            ⚠ Esta acción eliminará:
          </p>

          <ul style="margin:0 0 12px 18px; padding:0; font-size:14px; color:#374151;">
            <li>Todos los datos del cliente</li>
            <li>Todos sus anteojos (${clienteSeleccionado.anteojos?.length || 0})</li>
            <li>Todo el historial asociado</li>
          </ul>

          <p style="margin:0; text-align:center; color:#dc2626; font-weight:800; font-size:30px;">
            Esta acción NO se puede deshacer
          </p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    });

    if (!result.isConfirmed) return;

    try {
      await eliminarCliente(clienteSeleccionado.id);
      
      await Swal.fire({
        title: 'Cliente eliminado',
        text: 'El cliente y todos sus datos han sido eliminados correctamente',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
      
      // Cerrar el modal y refrescar la lista
      setMostrarDetalles(false);
      setEditandoCliente(false);
      cargarClientes();
      
    } catch (error) {
      await Swal.fire({
        title: 'Error al eliminar',
        text: error.message || 'No se pudo eliminar el cliente',
        icon: 'error'
      });
    }
  };

  // Funciones para editar y eliminar ventas
  const abrirEditarVenta = (venta) => {
    setVentaParaEditar(venta);
    setMostrarEditarVenta(true);
  };

  const eliminarVentaConfirmar = async () => {
    if (!ventaParaEliminar) return;
    
    try {
      await eliminarVenta(ventaParaEliminar.id);
      
      await Swal.fire({
        title: 'Venta eliminada',
        text: 'La venta ha sido eliminada correctamente',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
      
      // Refrescar la lista de ventas
      if (clienteSeleccionado) {
        const respuestaVentas = await obtenerVentas({ cliente_id: clienteSeleccionado.id });
        setVentasCliente(respuestaVentas.ventas || []);
      }
      
      setVentaParaEliminar(null);
      
    } catch (error) {
      await Swal.fire({
        title: 'Error al eliminar',
        text: error.message || 'No se pudo eliminar la venta',
        icon: 'error'
      });
    }
  };

  if (loading && clientes.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900"><UsersIcon className="h-6 w-6 inline mr-2" /> Lista de Clientes</h1>
          <p className="text-gray-600 mt-2">Gestiona clientes y sus anteojos</p>
        </div>

        {/* Barra de búsqueda y acciones */}
        <div className="bg-white shadow-sm border border-gray-200/80 rounded-2xl p-4 sm:p-5 mb-6">
          <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-4">
            {/* Buscador responsivo */}
            <div className="relative flex-1 max-w-xl">
              <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                {loading && busqueda ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                ) : (
                  <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
                )}
              </div>
              <input
                type="text"
                placeholder="Buscar por nombre, apellido o teléfono..."
                value={busqueda}
                onChange={handleBusqueda}
                className="block w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-xl leading-5 bg-white placeholder-gray-400 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
              />
              {busqueda && (
                <button
                  type="button"
                  onClick={() => {
                    setBusqueda('');
                    cargarClientes();
                  }}
                  className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <XMarkIcon className="h-4 w-4" />
                </button>
              )}
            </div>

            {/* Controles y estadísticas */}
            <div className="flex flex-wrap sm:flex-nowrap items-center justify-between lg:justify-end gap-2.5 sm:gap-3 shrink-0">
              <button
                type="button"
                onClick={cargarClientes}
                className="inline-flex items-center justify-center gap-1.5 px-3.5 py-2 border border-gray-300 shadow-2xs text-xs sm:text-sm font-semibold rounded-xl text-gray-700 bg-white hover:bg-gray-50 active:bg-gray-100 transition-colors cursor-pointer"
              >
                <ArrowPathIcon className="h-4 w-4 text-gray-500" />
                <span>Actualizar</span>
              </button>
              <button
                type="button"
                onClick={() => setMostrarSobreNuevo(true)}
                className="inline-flex items-center justify-center gap-1.5 px-3.5 py-2 border border-indigo-200 shadow-2xs text-xs sm:text-sm font-semibold rounded-xl text-indigo-700 bg-indigo-50/80 hover:bg-indigo-100 active:bg-indigo-200/70 transition-colors cursor-pointer"
              >
                <PrinterIcon className="h-4 w-4 text-indigo-600" />
                <span>Nuevo sobre en blanco</span>
              </button>
              <div className="inline-flex items-center gap-1.5 px-3 py-2 bg-slate-100/80 rounded-xl text-xs sm:text-sm font-medium text-slate-600 whitespace-nowrap">
                {busqueda ? (
                  <>
                    <ClipboardDocumentListIcon className="h-4 w-4 text-blue-600 shrink-0" />
                    <span>{clientesFiltrados.length} resultado{clientesFiltrados.length !== 1 ? 's' : ''}</span>
                  </>
                ) : (
                  <>
                    <ChartBarIcon className="h-4 w-4 text-slate-500 shrink-0" />
                    <span>Total: <strong className="font-semibold text-slate-800">{clientes.length}</strong></span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Error */}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
            <strong>Error:</strong> {error}
          </div>
        )}

        {/* Lista de clientes */}
        <div className="bg-white shadow overflow-hidden sm:rounded-md">
          <ul className="divide-y divide-gray-200">
            {clientesPaginados.map((cliente) => (
              <li key={cliente.id} className="py-2"> {/* Espacio extra entre registros */}
                <div
                  className="px-4 py-3 sm:px-6 sm:py-5 hover:bg-gray-50 cursor-pointer rounded-lg transition-shadow shadow-sm mb-2"
                  onClick={e => {
                    // Evitar que el click en los botones de estado, borrar o agregar anteojo dispare el modal
                    if (
                      e.target.closest('.btn-agregar-anteojo') ||
                      e.target.closest('.btn-borrar-anteojo') ||
                      e.target.closest('.btn-estado-anteojo')
                    ) return;
                    verDetallesCliente(cliente.id);
                  }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex items-center min-w-0 flex-1">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                          <span className="text-sm font-medium text-blue-600">
                            {cliente.nombre.charAt(0)}{cliente.apellido.charAt(0)}
                          </span>
                        </div>
                      </div>
                      <div className="ml-3 min-w-0">
                        <div className="flex items-center flex-wrap gap-x-2">
                          <div className="text-sm font-medium text-gray-900 truncate">
                            {cliente.nombre} {cliente.apellido}
                          </div>
                          <div className="flex-shrink-0 flex items-center gap-2">
                            {cliente.total_anteojos > 0 && (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                {cliente.total_anteojos} anteojo{cliente.total_anteojos !== 1 ? 's' : ''}
                              </span>
                            )}
                            {cliente.total_ventas > 0 && (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                {cliente.total_ventas} venta{cliente.total_ventas !== 1 ? 's' : ''}
                              </span>
                            )}
                            {resumenGarantiasPorCliente[cliente.id]?.garantias_en_proceso > 0 && (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                ⚠️ {resumenGarantiasPorCliente[cliente.id].garantias_en_proceso} garantía{resumenGarantiasPorCliente[cliente.id].garantias_en_proceso !== 1 ? 's' : ''}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="mt-2 sm:flex sm:justify-between">
                          <div className="sm:flex">
                            <div className="mr-6 flex items-center gap-1 text-sm text-gray-500">
                              <PhoneIcon className="h-4 w-4" /> {cliente.telefono}
                            </div>
                            <div className="mt-2 flex items-center gap-1 text-sm text-gray-500 sm:mt-0">
                              <CalendarIcon className="h-4 w-4" /> {formatearFecha(cliente.fecha_registro)}
                            </div>
                            {/* Mostrar último anteojo regular y/o lentes de contacto */}
                            {(cliente.ultimo_regular_estado || cliente.ultimo_lentes_estado) ? (
                              <div className="mt-2 flex flex-wrap items-center gap-2 sm:mt-0 sm:ml-4">
                                {cliente.ultimo_regular_estado && (
                                  <div className="flex items-center gap-1">
                                    <EyeIcon className="h-3 w-3 text-gray-400" />
                                    {cliente.ultimo_regular_nro_sobre && (
                                      <span className="text-xs text-gray-400">#{cliente.ultimo_regular_nro_sobre}</span>
                                    )}
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getEstadoColor(cliente.ultimo_regular_estado)}`}>
                                      {cliente.ultimo_regular_estado}
                                    </span>
                                  </div>
                                )}
                                {cliente.ultimo_lentes_estado && (
                                  <div className="flex items-center gap-1">
                                    <span className="text-xs text-gray-400">👁</span>
                                    {cliente.ultimo_lentes_nro_sobre && (
                                      <span className="text-xs text-gray-400">#{cliente.ultimo_lentes_nro_sobre}</span>
                                    )}
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getEstadoColor(cliente.ultimo_lentes_estado)}`}>
                                      LC · {cliente.ultimo_lentes_estado}
                                    </span>
                                  </div>
                                )}
                              </div>
                            ) : cliente.ultimo_anteojo_estado ? (
                              <div className="mt-2 flex items-center gap-1 text-sm sm:mt-0 sm:ml-6">
                                <EyeIcon className="h-4 w-4" />
                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getEstadoColor(cliente.ultimo_anteojo_estado)}`}>
                                  {cliente.ultimo_anteojo_estado}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 justify-end sm:flex-shrink-0">
                      <button
                        onClick={e => { e.stopPropagation(); verDetallesCliente(cliente.id); }}
                        className="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      >
                        <EyeIcon className="h-4 w-4" /> Ver detalles
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setClienteParaAgregarVenta(cliente);
                          setMostrarAgregarVenta(true);
                        }}
                        className="inline-flex items-center gap-1 px-3 py-1.5 border border-green-300 text-xs font-medium rounded text-green-700 bg-green-50 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      >
                        <BanknotesIcon className="h-4 w-4" /> Agregar venta
                      </button>
                      <button
                        className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 btn-agregar-anteojo disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={cargandoModal}
                        onClick={async (e) => {
                          e.stopPropagation();
                          try {
                            setCargandoModal(true);
                            
                            // Obtener detalles completos del cliente para conseguir los anteojos
                            const clienteCompleto = await obtenerClienteCompleto(cliente.id);
                            
                            // Preparar datos para el último anteojo
                            const ultimo = clienteCompleto.anteojos && clienteCompleto.anteojos.length > 0
                              ? [...clienteCompleto.anteojos].sort((a, b) => (b.id || 0) - (a.id || 0))[0]
                              : null;
                            
                            // Usar doble requestAnimationFrame para asegurar que el DOM se actualice completamente
                            requestAnimationFrame(() => {
                              requestAnimationFrame(() => {
                                setClienteParaAgregarAnteojo(clienteCompleto);
                                setUltimoAnteojoCliente(ultimo);
                                setMostrarAgregarAnteojo(true);
                                setCargandoModal(false);
                              });
                            });
                          } catch (error) {
                            console.error('Error al abrir modal de anteojo desde lista:', error);
                            setCargandoModal(false);
                          }
                        }}
                      >
                        {cargandoModal ? (
                          <>
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white mr-1"></div>
                            <span>Cargando...</span>
                          </>
                        ) : (
                          <>
                            <PlusIcon className="h-4 w-4" /> Agregar anteojo
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {clientesFiltrados.length === 0 && !loading && (
            <div className="text-center py-12">
              <MagnifyingGlassIcon className="h-16 w-16 mx-auto text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No se encontraron clientes</h3>
              <p className="mt-1 text-sm text-gray-500">
                {busqueda ? 'Intenta con otros términos de búsqueda' : 'Comienza agregando un nuevo cliente'}
              </p>
            </div>
          )}

          {/* Controles de paginación */}
          {clientesFiltrados.length > 0 && (
            <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-700">Items por página:</span>
                <select
                  value={itemsPorPagina}
                  onChange={(e) => {
                    setItemsPorPagina(Number(e.target.value));
                    setPaginaActual(1);
                  }}
                  className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                </select>
              </div>

              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-700">
                  Página <span className="font-medium">{paginaActual}</span> de <span className="font-medium">{totalPaginas}</span>
                  <span className="ml-2">({indiceInicio + 1}-{Math.min(indiceFin, clientesFiltrados.length)} de {clientesFiltrados.length})</span>
                </span>
              </div>

              <div className="flex items-center gap-1">
                <button
                  onClick={() => setPaginaActual(1)}
                  disabled={paginaActual === 1}
                  className="px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ⟨⟨
                </button>
                <button
                  onClick={() => setPaginaActual(Math.max(1, paginaActual - 1))}
                  disabled={paginaActual === 1}
                  className="px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ⟨
                </button>

                {/* Botones de páginas */}
                <div className="flex items-center gap-1">
                  {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
                    let pageNum;
                    if (totalPaginas <= 5) {
                      pageNum = i + 1;
                    } else if (paginaActual <= 3) {
                      pageNum = i + 1;
                    } else if (paginaActual >= totalPaginas - 2) {
                      pageNum = totalPaginas - 4 + i;
                    } else {
                      pageNum = paginaActual - 2 + i;
                    }
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setPaginaActual(pageNum)}
                        className={`px-2 py-1 border rounded-md text-sm font-medium ${
                          paginaActual === pageNum
                            ? 'bg-blue-600 text-white border-blue-600'
                            : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                </div>

                <button
                  onClick={() => setPaginaActual(Math.min(totalPaginas, paginaActual + 1))}
                  disabled={paginaActual === totalPaginas}
                  className="px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ⟩
                </button>
                <button
                  onClick={() => setPaginaActual(totalPaginas)}
                  disabled={paginaActual === totalPaginas}
                  className="px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ⟩⟩
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Modal de detalles del cliente */}
        {mostrarDetalles && clienteSeleccionado && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
            <div className="relative top-20 mx-auto p-5 border w-11/12 lg:w-3/4 xl:w-1/2 shadow-lg rounded-md bg-white">
              {/* Header del modal */}
              <div className="flex items-center justify-between pb-4 border-b">
                <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                  <UserIcon className="h-6 w-6" /> {clienteSeleccionado.nombre} {clienteSeleccionado.apellido}
                </h3>
                <button
                  onClick={() => {
                    setMostrarDetalles(false);
                    setEditandoCliente(false);
                  }}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>

              {/* Información del cliente */}
              <div className="mt-4">
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-sm font-medium text-gray-900">Información Personal</h4>
                    {!editandoCliente && (
                      <button
                        onClick={iniciarEdicionCliente}
                        className="text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center gap-1"
                      >
                        <PencilIcon className="h-4 w-4" />
                        <span>Editar</span>
                      </button>
                    )}
                  </div>
                  
                  {editandoCliente ? (
                    // Modo edición
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Nombre*</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.nombre}
                            onChange={(e) => handleCambioEdicionCliente('nombre', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Nombre"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Apellido*</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.apellido}
                            onChange={(e) => handleCambioEdicionCliente('apellido', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Apellido"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Teléfono*</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.telefono}
                            onChange={(e) => handleCambioEdicionCliente('telefono', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Teléfono"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Padre/Madre/Encargado</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.padre_madre_encargado}
                            onChange={(e) => handleCambioEdicionCliente('padre_madre_encargado', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Opcional"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Domicilio</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.domicilio}
                            onChange={(e) => handleCambioEdicionCliente('domicilio', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Opcional"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">E-mail</label>
                          <input
                            type="email"
                            value={datosEdicionCliente.email}
                            onChange={(e) => handleCambioEdicionCliente('email', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Opcional"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Obra Social</label>
                          <input
                            type="text"
                            value={datosEdicionCliente.obra_social}
                            onChange={(e) => handleCambioEdicionCliente('obra_social', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Opcional"
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
                        <textarea
                          value={datosEdicionCliente.observaciones}
                          onChange={(e) => handleCambioEdicionCliente('observaciones', e.target.value)}
                          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Opcional"
                          style={{ minHeight: '80px', fontFamily: 'inherit' }}
                        />
                      </div>
                      <div className="flex items-center justify-end space-x-3 pt-3 border-t">
                        <button
                          onClick={cancelarEdicionCliente}
                          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={guardarEdicionCliente}
                          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                        >
                          Guardar cambios
                        </button>
                      </div>
                    </div>
                  ) : (
                    // Modo solo lectura
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="font-medium text-gray-500">Nombre:</span>
                        <span className="ml-2">{clienteSeleccionado.nombre}</span>
                      </div>
                      <div>
                        <span className="font-medium text-gray-500">Apellido:</span>
                        <span className="ml-2">{clienteSeleccionado.apellido}</span>
                      </div>
                      <div>
                        <span className="font-medium text-gray-500">Teléfono:</span>
                        <span className="ml-2">{clienteSeleccionado.telefono}</span>
                      </div>
                      <div>
                        <span className="font-medium text-gray-500">Fecha registro:</span>
                        <span className="ml-2">{formatearFecha(clienteSeleccionado.fecha_registro)}</span>
                      </div>
                      {clienteSeleccionado.padre_madre_encargado && (
                        <div className="sm:col-span-2">
                          <span className="font-medium text-gray-500">Padre/Madre/Encargado:</span>
                          <span className="ml-2">{clienteSeleccionado.padre_madre_encargado}</span>
                        </div>
                      )}
                      {clienteSeleccionado.domicilio && (
                        <div className="sm:col-span-2">
                          <span className="font-medium text-gray-500">Domicilio:</span>
                          <span className="ml-2">{clienteSeleccionado.domicilio}</span>
                        </div>
                      )}
                      {clienteSeleccionado.email && (
                        <div className="sm:col-span-2">
                          <span className="font-medium text-gray-500">E-mail:</span>
                          <span className="ml-2">{clienteSeleccionado.email}</span>
                        </div>
                      )}
                      {clienteSeleccionado.obra_social && (
                        <div className="sm:col-span-2">
                          <span className="font-medium text-gray-500">Obra Social:</span>
                          <span className="ml-2">{clienteSeleccionado.obra_social}</span>
                        </div>
                      )}
                      {clienteSeleccionado.observaciones && (
                        <div className="sm:col-span-2">
                          <span className="font-medium text-gray-500">Observaciones:</span>
                          <p className="ml-2 mt-1 text-gray-700 whitespace-pre-wrap">{clienteSeleccionado.observaciones}</p>
                        </div>
                      )}

                      {/* Estado y Toggle de Reseña en Google (solo visible si fue solicitada previamente o si ya fue marcada realizada) */}
                      {(clienteSeleccionado.review_solicitado || clienteSeleccionado.review_realizado) && (
                        <div className="sm:col-span-2 flex items-center justify-between p-3 bg-amber-50/70 border border-amber-200 rounded-xl mt-2">
                          <div className="flex items-center gap-2">
                            <span className="text-base">⭐</span>
                            <div>
                              <p className="text-xs font-bold text-amber-900">Reseña en Google</p>
                              <p className="text-[11px] text-amber-700">
                                {clienteSeleccionado.review_realizado
                                  ? 'El cliente ya dejó su reseña'
                                  : (clienteSeleccionado.fecha_review_solicitado
                                      ? `Solicitada el ${formatearFechaArgentina(clienteSeleccionado.fecha_review_solicitado)} (${calcularTiempoTranscurrido(clienteSeleccionado.fecha_review_solicitado)})`
                                      : 'Solicitada previamente')}
                              </p>
                            </div>
                          </div>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={Boolean(clienteSeleccionado.review_realizado)}
                              onChange={async (e) => {
                                const val = e.target.checked;
                                try {
                                  await actualizarEstadoReviewCliente(clienteSeleccionado.id, val);
                                  const act = await obtenerClienteCompleto(clienteSeleccionado.id);
                                  setClienteSeleccionado(act);
                                  setClientes(prev => prev.map(c => c.id === clienteSeleccionado.id ? { ...c, review_realizado: val } : c));
                                } catch (err) {
                                  Swal.fire('Error', 'No se pudo actualizar el estado de la reseña', 'error');
                                }
                              }}
                              className="sr-only peer"
                            />
                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-amber-500"></div>
                            <span className="ml-2 text-xs font-semibold text-gray-700 select-none">
                              {clienteSeleccionado.review_realizado ? 'Realizada' : 'Pendiente'}
                            </span>
                          </label>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Lista de anteojos */}
                <div>
                  <h4 className="text-sm font-medium text-gray-900 mb-3 flex items-center gap-2">
                    <EyeIcon className="h-5 w-5" /> Anteojos ({clienteSeleccionado.anteojos?.length || 0})
                  </h4>
                  {clienteSeleccionado.anteojos && clienteSeleccionado.anteojos.length > 0 ? (
                    <div className="space-y-3 max-h-60 overflow-y-auto">
                      {clienteSeleccionado.anteojos.map((anteojo) => (
                        <div key={anteojo.id} className="border border-gray-200 rounded-lg p-3">
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center space-x-2 flex-wrap gap-1">
                              <span className="text-sm font-medium">
                                {anteojo.tipo_anteojo || 'General'}
                              </span>
                              {obtenerDistanciaMonofocal(anteojo) && (
                                <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${obtenerColorDistancia(obtenerDistanciaMonofocal(anteojo))}`}>
                                  {obtenerDistanciaMonofocal(anteojo) === 'lejos' ? (
                                    <>
                                      <EyeIcon className="h-3 w-3" />
                                      Lejos
                                    </>
                                  ) : (
                                    <>
                                      <BookOpenIcon className="h-3 w-3" />
                                      Cerca
                                    </>
                                  )}
                                </span>
                              )}
                              {anteojo.nro_sobre && (
                                <span className="text-xs text-gray-500">
                                  Sobre #{anteojo.nro_sobre}
                                </span>
                              )}
                            </div>
                            <div className="flex items-center gap-1.5 flex-wrap justify-end">
                              {(() => {
                                const facturaAsociada = encontrarFacturaDeAnteojo(anteojo, facturasCliente);
                                if (facturaAsociada) {
                                  return (
                                    <button
                                      type="button"
                                      className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-300 hover:bg-emerald-100 transition shadow-sm"
                                      onClick={() => verODescargarFactura(facturaAsociada, descargarFacturaPDF)}
                                      title={`Factura emitida: ${facturaAsociada.numero_comprobante || facturaAsociada.numero_factura}. Clic para ver o descargar`}
                                    >
                                      <DocumentArrowDownIcon className="h-3.5 w-3.5 text-emerald-600" />
                                      <span>Ver / Descargar Factura</span>
                                    </button>
                                  );
                                }
                                if (Number(anteojo.saldo || 0) <= 0) {
                                  return (
                                    <button
                                      type="button"
                                      className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-300 hover:bg-emerald-100 transition shadow-sm"
                                      onClick={() => solicitarFacturacionAnteojo({ cliente: clienteSeleccionado, anteojo, onViewChange })}
                                      title="Realizar factura de este anteojo"
                                    >
                                      <DocumentTextIcon className="h-3.5 w-3.5 text-emerald-600" />
                                      <span>Realizar Factura</span>
                                    </button>
                                  );
                                }
                                return null;
                              })()}
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getEstadoColor(anteojo.estado)}`}>
                                {anteojo.estado}
                              </span>
                            </div>
                          </div>
                          {/* Botones de cambio de estado */}
                          {(() => {
                            const estadosOrden = ['Tomado','Preparado','En laboratorio','Para retirar','Entregado'];
                            const estadoActualIdx = estadosOrden.indexOf(anteojo.estado);
                            const estadosDisponibles = estadoActualIdx >= 0 ? estadosOrden.slice(estadoActualIdx + 1) : [];
                            return estadosDisponibles.length > 0 ? (
                              <div className="flex flex-wrap gap-2 mb-3">
                                {estadosDisponibles.map((estado) => (
                                  <button
                                    key={estado}
                                    onClick={() => cambiarEstadoAnteojo(anteojo.id, estado)}
                                    disabled={actualizandoEstado === anteojo.id}
                                    className={
                                      `px-3 py-1.5 text-xs rounded border disabled:opacity-50 btn-estado-anteojo flex items-center gap-1 ` +
                                      (estado === 'Tomado' ? 'bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-200' :
                                      estado === 'Preparado' ? 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200' :
                                      estado === 'En laboratorio' ? 'bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-200' :
                                      estado === 'Para retirar' ? 'bg-green-100 text-green-800 border-green-200 hover:bg-green-200' :
                                      'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200')
                                    }
                                  >
                                    {actualizandoEstado === anteojo.id && <ArrowPathIcon className="h-3 w-3 animate-spin" />}
                                    {estado}
                                  </button>
                                ))}
                              </div>
                            ) : null;
                          })()}
                            <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
                            <div><BanknotesIcon className="h-4 w-4 inline mr-1 bg-green-100 rounded-md" /> Total: {formatearMoneda(anteojo.precio_total)}</div>
                            <div><CalendarIcon className="h-4 w-4 inline mr-1 bg-blue-100 rounded-md" /> {formatearFecha(anteojo.fecha_pedido)}</div>
                            <div><CreditCardIcon className="h-4 w-4 inline mr-1 bg-yellow-100 rounded-md" /> Seña: {formatearMoneda(anteojo.sena)}</div>
                            <div><BanknotesIcon className="h-4 w-4 inline mr-1 bg-red-100 rounded-md" /> Saldo: {formatearMoneda(anteojo.saldo)}</div>
                            <div>
                              <span className="font-medium">Cristal:</span> {anteojo.lejos_cristal || anteojo.cerca_cristal || '-'}
                            </div>
                            <div>
                              <span className="font-medium">Armazón:</span> {anteojo.lejos_armazon || anteojo.cerca_armazon || '-'}
                            </div>
                          </div>
                          {anteojo.observaciones && (
                            <div className="mb-3 text-xs text-gray-500 italic">
                              "{anteojo.observaciones}"
                            </div>
                          )}
                          <div className="flex flex-wrap gap-1 mb-2">
                            {!esAnteojoCreadoPorBeneficio(anteojo) && !anteojo.usa_seguro && beneficiosDisponiblesPorAnteojo[anteojo.id]?.seguro && (
                              <button
                                type="button"
                                className="px-2 py-1 text-xs bg-emerald-100 text-emerald-800 rounded border border-emerald-300 hover:bg-emerald-200"
                                onClick={() => activarBeneficioDesdeLista(anteojo, 'usa_seguro')}
                                disabled={cargandoModal}
                              >
                                Usar Seguro
                              </button>
                            )}
                            {!esAnteojoCreadoPorBeneficio(anteojo) && !anteojo.usa_promocion && beneficiosDisponiblesPorAnteojo[anteojo.id]?.promocion && (
                              <button
                                type="button"
                                className="px-2 py-1 text-xs bg-lime-100 text-lime-800 rounded border border-lime-300 hover:bg-lime-200"
                                onClick={() => activarBeneficioDesdeLista(anteojo, 'usa_promocion')}
                                disabled={cargandoModal}
                              >
                                Usar Promoción
                              </button>
                            )}
                          </div>

                          <div className="flex gap-2 mb-3">
                            <button
                              className="flex-1 px-2 py-1.5 text-xs bg-gray-100 text-gray-800 rounded border border-gray-300 hover:bg-gray-200 flex items-center justify-center gap-1"
                              onClick={() => setAnteojoDetalle(anteojo)}
                            >
                              <EyeIcon className="h-3 w-3" /> Ver detalles
                            </button>
                            <button
                              className="flex-1 px-2 py-1.5 text-xs bg-indigo-50 text-indigo-700 rounded border border-indigo-200 hover:bg-indigo-100 flex items-center justify-center gap-1"
                              onClick={() => setAnteojoParaImprimir(anteojo)}
                            >
                              <PrinterIcon className="h-3 w-3" /> Imprimir sobre
                            </button>
                            <button
                              className="flex-1 px-2 py-1.5 text-xs bg-red-100 text-red-800 rounded border border-red-300 hover:bg-red-200 btn-borrar-anteojo flex items-center justify-center gap-1"
                              onClick={async e => {
                                e.stopPropagation();
                                await borrarAnteojo(anteojo.id);
                                // Actualizar la lista de anteojos en el modal después de borrar
                                if (clienteSeleccionado) {
                                  const actualizado = await obtenerClienteCompleto(clienteSeleccionado.id);
                                  setClienteSeleccionado(actualizado);
                                }
                                // Si el anteojo borrado estaba en detalle, cerrar el modal de detalle
                                if (anteojoDetalle && anteojoDetalle.id === anteojo.id) {
                                  setAnteojoDetalle(null);
                                }
                              }}
                            >
                              <TrashIcon className="h-3 w-3" /> Borrar
                            </button>
                          </div>
      {/* Modal de detalle/edición de anteojo */}
      {anteojoDetalle && (
        <AnteojoDetalle
          anteojo={anteojoDetalle}
          cliente={clienteSeleccionado}
          facturasCliente={facturasCliente}
          onClose={() => setAnteojoDetalle(null)}
          onEstadoChange={cambiarEstadoAnteojo}
          onViewChange={onViewChange}
          onAplicarBeneficioYReplicar={handleAplicarBeneficioYReplicar}
          onSave={async (data) => {
            // Guardar cambios reales usando editarAnteojo
            await editarAnteojo(data.id, data);
            await verDetallesCliente(clienteSeleccionado.id);
            setAnteojoDetalle(null);
          }}
        />
      )}

                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4 text-gray-500">
                      <EyeIcon className="h-12 w-12 mx-auto text-gray-300" />
                      <p className="text-sm mt-1">Este cliente no tiene anteojos registrados</p>
                    </div>
                  )}
                </div>

                {/* Lista de ventas */}
                <div>
                  <h4 className="text-sm font-medium text-gray-900 mb-3 flex items-center gap-2">
                    <BanknotesIcon className="h-5 w-5" /> Ventas ({ventasCliente?.length || 0})
                  </h4>
                  {ventasCliente && ventasCliente.length > 0 ? (
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                      {ventasCliente.map((venta) => (
                        <div
                          key={venta.id}
                          className="p-3 border border-gray-200 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
                        >
                          <div className="flex items-center justify-between mb-2">
                            <span className="font-medium text-gray-900">
                              {venta.tipo_venta_nombre || venta.tipo_venta_id || 'Venta'}
                            </span>
                           
                              
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-bold text-green-700">
                                ${Number(venta.monto).toLocaleString('es-AR')}
                              </span>
                              {(() => {
                                const facturaVenta = encontrarFacturaDeVenta(venta, facturasCliente);
                                if (facturaVenta) {
                                  return (
                                    <button
                                      type="button"
                                      onClick={() => verODescargarFactura(facturaVenta, descargarFacturaPDF)}
                                      className="p-1 text-emerald-600 hover:bg-emerald-100 rounded transition-colors"
                                      title="Ver / Descargar Factura"
                                    >
                                      <DocumentArrowDownIcon className="h-4 w-4" />
                                    </button>
                                  );
                                }
                                return (
                                  <button
                                    type="button"
                                    onClick={() => solicitarFacturacionVenta({ cliente: clienteSeleccionado, venta, onViewChange })}
                                    className="p-1 text-emerald-600 hover:bg-emerald-100 rounded transition-colors"
                                    title="Realizar Factura"
                                  >
                                    <DocumentTextIcon className="h-4 w-4" />
                                  </button>
                                );
                              })()}
                              <button
                                onClick={() => abrirEditarVenta(venta)}
                                className="p-1 text-blue-600 hover:bg-blue-100 rounded transition-colors"
                                title="Editar venta"
                              >
                                <PencilIcon className="h-4 w-4" />
                              </button>
                              <button
                                onClick={() => setVentaParaEliminar(venta)}
                                className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors"
                                title="Eliminar venta"
                              >
                                <TrashIcon className="h-4 w-4" />
                              </button>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2 text-xs text-gray-600">
                            <div>
                              <CalendarIcon className="h-3 w-3 inline mr-1" />
                              {formatearFecha(venta.fecha_venta)}
                            </div>
                            <div>
                              <CreditCardIcon className="h-4 w-4 inline mr-2" />
                              {venta.tipo_pago || '-'}
                            </div>
                            {venta.descripcion && (
                              <div className="col-span-3">
                                <span className="font-bold">Descripción:</span> {venta.descripcion}
                              </div>
                            )}
                            {venta.nombre_armazon && (
                              <div className="col-span-2">
                                <span className="font-medium">Armazón:</span> {venta.nombre_armazon}
                              </div>
                            )}
                            {!venta.nombre_armazon && venta.armazon_marca && (
                              <div className="col-span-2">
                                <span className="font-medium">Armazón:</span> {venta.armazon_marca} {venta.armazon_modelo} - {venta.armazon_color}
                              </div>
                            )}
                            {venta.armazon_descripcion && (
                              <div className="col-span-2">
                                <span className="font-medium">Armazón:</span> {venta.armazon_descripcion}
                              </div>
                            )}
                            {venta.producto_descripcion && (
                              <div className="col-span-2">
                                <span className="font-medium">Producto:</span> {venta.producto_descripcion}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4 text-gray-500">
                      <BanknotesIcon className="h-12 w-12 mx-auto text-gray-300" />
                      <p className="text-sm mt-1">Este cliente no tiene ventas registradas</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Footer del modal */}
              <div className="flex items-stretch gap-2 pt-4 border-t mt-4">
                {/* Botón de eliminar cliente a la izquierda */}
                <button
                  onClick={eliminarClienteCompleto}
                  className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md flex items-center justify-center gap-2"
                >
                  <TrashIcon className="h-4 w-4" />
                  <span>Eliminar cliente</span>
                </button>
                
                {/* Botones de acción a la derecha */}
                  <button
                    onClick={() => {
                      setMostrarDetalles(false);
                      setEditandoCliente(false);
                    }}
                    className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md flex items-center justify-center"
                  >
                    Cerrar
                  </button>
                  <button
                    className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    disabled={cargandoModal}
                    onClick={async () => {
                      try {
                        setCargandoModal(true);
                        
                        // Preparar datos inmediatamente
                        const ultimo = clienteSeleccionado.anteojos && clienteSeleccionado.anteojos.length > 0
                          ? [...clienteSeleccionado.anteojos].sort((a, b) => (b.id || 0) - (a.id || 0))[0]
                          : null;

                        abrirModalAgregarAnteojo(clienteSeleccionado, ultimo);
                        setCargandoModal(false);
                      } catch (error) {
                        console.error('Error al abrir modal de anteojo:', error);
                        setCargandoModal(false);
                      }
                    }}
                  >
                    {cargandoModal ? (
                      <>
                        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                        <span>Cargando...</span>
                      </>
                    ) : (
                      <>
                        <PlusIcon className="h-4 w-4" />
                        <span>Agregar anteojo</span>
                      </>
                    )}
                  </button>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Modal ClienteForm para agregar anteojo - Renderizado independiente */}
      {mostrarAgregarAnteojo && clienteParaAgregarAnteojo && (
        <div key={`modal-${clienteParaAgregarAnteojo.id}-${Date.now()}`} className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[65]">
          <ClienteForm
            key={`clienteform-${clienteParaAgregarAnteojo.id}-${Date.now()}`}
            modoAgregarAnteojo
            clienteExistente={clienteParaAgregarAnteojo}
            ultimoAnteojo={ultimoAnteojoCliente}
            origenBeneficio={origenBeneficioAnteojo}
            onViewChange={onViewChange}
            onClose={() => {
              setMostrarAgregarAnteojo(false);
              setClienteParaAgregarAnteojo(null);
              setUltimoAnteojoCliente(null);
              setOrigenBeneficioAnteojo(null);
              setCargandoModal(false);
              // Refrescar detalles del cliente para ver el nuevo anteojo
              if (clienteSeleccionado) verDetallesCliente(clienteSeleccionado.id);
            }}
          />
        </div>
      )}

      {/* Spinner flotante para operaciones de modal */}
      {cargandoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[70]">
          <div className="bg-white rounded-lg p-6 flex items-center space-x-3 shadow-xl">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            <span className="text-gray-700 font-medium">Preparando formulario...</span>
          </div>
        </div>
      )}

      {/* Modal de impresión de sobre */}
      {anteojoParaImprimir && (
        <PrintSobre
          anteojo={anteojoParaImprimir}
          cliente={clienteSeleccionado}
          onClose={() => setAnteojoParaImprimir(null)}
        />
      )}

      {/* Sobre en blanco */}
      {mostrarSobreNuevo && (
        <PrintSobre
          anteojo={null}
          cliente={null}
          onClose={() => setMostrarSobreNuevo(false)}
        />
      )}

      {/* Modal para agregar venta a cliente */}
      {mostrarAgregarVenta && clienteParaAgregarVenta && (
        <VentaModal
          onClose={() => {
            setMostrarAgregarVenta(false);
            setClienteParaAgregarVenta(null);
          }}
          onSuccess={(result) => {
            // Refrescar la lista de clientes
            cargarClientes();
            
            // Si se creó un cliente nuevo en la venta y el usuario quiso verlo
            if (result?.cliente_id) {
              setTimeout(() => {
                verDetallesCliente(result.cliente_id);
              }, 500);
            }
          }}
          clienteId={clienteParaAgregarVenta.id}
          clienteDatos={clienteParaAgregarVenta}
        />
      )}

      {/* Modal para editar venta */}
      {mostrarEditarVenta && ventaParaEditar && (
        <VentaModal
          venta={ventaParaEditar}
          onClose={() => {
            setMostrarEditarVenta(false);
            setVentaParaEditar(null);
          }}
          onSuccess={() => {
            // Refrescar la lista de ventas
            if (clienteSeleccionado) {
              verDetallesCliente(clienteSeleccionado.id);
            }
          }}
        />
      )}

      {/* Modal de confirmación para eliminar venta */}
      {ventaParaEliminar && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
            <h3 className="text-lg font-bold text-gray-900 mb-2">¿Eliminar venta?</h3>
            <p className="text-gray-600 mb-4">
              ¿Estás seguro de que deseas eliminar esta venta de <strong>${Number(ventaParaEliminar.monto).toLocaleString('es-AR')}</strong>?
            </p>
            <div className="flex gap-2 justify-end">
              <button
                onClick={() => setVentaParaEliminar(null)}
                className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={eliminarVentaConfirmar}
                className="px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-lg font-medium transition-colors"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListaClientes;
